import { render } from "./PasswordChangePage.vue?vue&type=template&id=1337d834&scoped=true"
import script from "./PasswordChangePage.vue?vue&type=script&lang=ts"
export * from "./PasswordChangePage.vue?vue&type=script&lang=ts"

import "./PasswordChangePage.vue?vue&type=style&index=0&id=1337d834&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1337d834"
/* hot reload */
if (module.hot) {
  script.__hmrId = "1337d834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1337d834', script)) {
    api.reload('1337d834', script)
  }
  
  module.hot.accept("./PasswordChangePage.vue?vue&type=template&id=1337d834&scoped=true", () => {
    api.rerender('1337d834', render)
  })

}

script.__file = "src/views/passwordChange/PasswordChangePage.vue"

export default script